import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { UserAuthIamService } from 'src/app/features/proof-of-life/services/user-auth-iam/user-auth-iam.service';
import User from 'src/app/features/proof-of-life/services/user-auth/User';
import { UtilLarguraTela } from 'src/app/utils/configuracoes/util-largura-tela';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-mobile-menu',
  templateUrl: './mobile-menu.component.html',
  styleUrls: ['./mobile-menu.component.scss']
})
export class MobileMenuComponent implements OnInit {
  @Input() menuIsOpen: boolean = false;
  @Input() produtosIsOpen: boolean = false;

  public userData = new User({});
  public loadingUser: boolean = false;
  public error: boolean = false;
  public loginError: boolean = false;
  public firstLetterName: string;
  public profileImage: any;

  constructor(
    private cookieService: CookieService,
    private iamService: UserAuthIamService,
    private router: Router
  ) { }

  public ngOnInit() {
    if (!UtilLarguraTela.checarLarguraTela()) {
    this.obterInformacoesMe();
    }
  }

  obterInformacoesMe() {
    this.loadingUser = true;
    if (sessionStorage.getItem("iam") !== null) {
      this.loadingUser = false;
      this.userData = JSON.parse(sessionStorage.getItem("iam"));
      this.firstLetterName = this.userData.fullName.charAt(0);
      this.profileImage = this.userData.picture;
      //Utilizado para gerar o protocolo do relatorio sintetico
      sessionStorage.setItem("document", this.userData.document);
      sessionStorage.setItem("email", this.userData.email);
    } else {
      this.iamService.accountData().subscribe(
        data => {
          this.userData = data;
          this.loadingUser = false;
          this.firstLetterName = this.userData.fullName.charAt(0);
          this.profileImage = this.userData.picture;
          sessionStorage.setItem("document",this.userData.document);
          sessionStorage.setItem("email",this.userData.email);
        },
        () => {
          this.loadingUser = false;
          this.error = true;
          this.loginError = true;
        }
      );
    }
  }


  redirectPaginaLogin() {
    window.location.href= environment.urlPortal + "/entrar?redirectUrl=" + environment.urlRedirecionamento;
  }

  resetStorage() {
    localStorage.clear();
    sessionStorage.clear();
    this.cookieService.deleteAll( "/ ",  ".serasa.com.br" );
    this.cookieService.deleteAll( "/ ",  ".serasa.dev" );
    this.router.navigate(["/"]);
    setTimeout(() => {  
      location.reload();
    }, 1000);
  }
}
